import PropTypes from "prop-types";
import classNames from "classnames";
import { DownloadLink } from "../../Link";
import FileIcon from "../FileIcon/FileIcon";
import styles from "./FileDownload.module.scss";
import { DownloadFile } from "../../../../features/file/dataTypes";
import { getTimestamp } from "../../../../utils/getTimestamp";

export const FileDownload = ({
  file,
  iconSize = 40,
  customCssClass,
}: {
  file: DownloadFile;
  iconSize?: number;
  customCssClass?: string;
}) => {
  return (
    <DownloadLink url={file.url} customCssClass={classNames(styles.link, customCssClass)}>
      <FileIcon size={iconSize} customCssClass={styles.checkIcon} fileName={file.name} />
      <div className={styles.title}>
        <p>{file.name}</p>
        {file.createdTimestamp && <sub>{getTimestamp(file.createdTimestamp)}</sub>}
      </div>
    </DownloadLink>
  );
};

const FileDownloadList = ({ files, customCssClass }: { files: DownloadFile[]; customCssClass?: string }) => {
  return (
    <ul className={customCssClass}>
      {files.map(file => (
        <li key={file.id}>
          <FileDownload file={file} />
        </li>
      ))}
    </ul>
  );
};

FileDownload.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string,
    createdTimestamp: PropTypes.number,
  }).isRequired,
  iconSize: PropTypes.number,
  customCssClass: PropTypes.string,
};

FileDownloadList.propTypes = {
  files: PropTypes.array.isRequired,
  customCssClass: PropTypes.string,
};

export default FileDownloadList;
